import "./style.scss";
import classNames from "classnames";
import ProductsFilters from "../ProductsFilters";
import CategoryLinks from "../CategoryLinks";
import { Button } from "reactstrap";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import CockpitEditLink from "../CockpitEditLink";

const ProductsPageAside = ({
  id,
  className,
  style,
  category,
  products,
  allProducts,
  activeFilters,
  setFilter,
  resetFilters
}) => {
  const t = useBjelinTranslations();
  const isFiltered = Object.keys(activeFilters).length > 0;
  const categoryId = category._id;

  return (
    <aside
      id={id}
      className={classNames("products-page-aside", className)}
      style={style}
    >
      <div style={{ height: "3.5rem" }}>
        {isFiltered ? (
          <Button
            onClick={() => resetFilters()}
            style={{
              marginBottom: 10
            }}
          >
            <Icon name="xmark" /> {t("reset.filters")}
          </Button>
        ) : (
          <h2
            style={{
              fontWeight: 400,
              fontSize: "1.2em",
              marginTop: "0.4em",
              textTransform: "uppercase",
              letterSpacing: "0.1em"
            }}
          >
            {t("action.filter")}
          </h2>
        )}
      </div>

      <CategoryLinks categoryId={categoryId} expandedOnInit />

      <ProductsFilters
        categoryId={categoryId}
        products={products}
        allProducts={allProducts}
        activeFilters={activeFilters}
        setFilter={setFilter}
      />

      <CockpitEditLink
        collection={"product_categories"}
        _id={categoryId}
        labelKey={"action.edit"}
        wrapper={children => <div>{children}</div>}
      />
    </aside>
  );
};

export default ProductsPageAside;
